import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  userLogged: false,
  userInformations: {},
  // Used to keep the curent state of the subscription
  subscription: {
    type: null,
    expirationDate: null,
    hasUnsubscribed: false
  },
  // Used to temporary store the user to resend confirmation code
  registeringUser: {
    validated: false,
    email: null
  },
  commands: {},
  idToken: null,
  keepOfflineMode: false
}

export default {
  state,
  getters,
  actions,
  mutations
}
